import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AddToCartWithAttributesPayload, ItemMinimalDetails } from 'src/app/shared-core/models/cart-data.model';
import { SwiperContainer } from 'swiper/element';

@Component({
    selector: 'app-related-products',
    templateUrl: './related-products.component.html',
    styleUrls: ['./related-products.component.scss']
})
export class RelatedProductsComponent {
    @Input() public source: string;
    @Input() public recommendations: ItemMinimalDetails[] = [];
    @Output() public addedToCart = new EventEmitter<AddToCartWithAttributesPayload>();
    @ViewChild('swiper') public swiper!: ElementRef<SwiperContainer>;
}